import React from 'react';
import ChannelCard from './ChannelCard/ChannelCard';

const Home = () => {
    return <ChannelCard />;
};

export default Home;
